import React from 'react'
import injectSheet from 'react-jss'
import styles from './separator.styles'
import classNames from 'classnames'

const Separator = ({ classes, className }) => (
  <span className={classNames(classes.separator, className)} />
)

export default injectSheet(styles)(Separator)
